import { AUTH, NAV, ONBOARDING } from "./transitions";

const AUTH_PATHS = new Set([
  "/login",
  "/signup",
  "/forgot-password",
]);

function normalizePath(pathname = "") {
  if (pathname.startsWith("/reset-password")) return "/reset-password";
  if (pathname.startsWith("/letter/")) return "/letter";
  if (pathname.startsWith("/verify-email")) return "/verify-email";
  return pathname;
}

function isAuthPath(path) {
  return AUTH_PATHS.has(path) || path === "/reset-password" || path === "/verify-email";
}

/**
 * Pick the Section 8 transition for a from → to navigation.
 * Enter animation is applied to the destination page.
 */
export function resolveRouteVariant(fromPathname, toPathname) {
  const from = normalizePath(fromPathname);
  const to = normalizePath(toPathname);

  if (from === to) {
    if (to === "/onboarding") return AUTH.toOnboarding;
    if (to === "/dashboard") return AUTH.toDashboard;
    if (to === "/settings") return NAV.toSettings;
    if (to === "/letter") return NAV.toEditor;
    if (to === "/signup") return AUTH.loginToSignup;
    if (to === "/forgot-password" || to === "/reset-password") {
      return AUTH.loginToReset;
    }
    return AUTH.toDashboard;
  }

  // 8.1 Authentication
  if (from === "/login" && to === "/signup") return AUTH.loginToSignup;
  if (from === "/signup" && to === "/login") return AUTH.signupToLogin;
  if (
    (from === "/login" || from === "/signup") &&
    (to === "/forgot-password" || to === "/reset-password")
  ) {
    return AUTH.loginToReset;
  }
  if (
    (from === "/forgot-password" || from === "/reset-password") &&
    (to === "/login" || to === "/signup")
  ) {
    return AUTH.signupToLogin;
  }
  if (
    (from === "/login" || from === "/signup" || from === "/verify-email") &&
    to === "/onboarding"
  ) {
    return AUTH.toOnboarding;
  }
  if (
    (from === "/login" || from === "/signup" || from === "/verify-email") &&
    to === "/dashboard"
  ) {
    return AUTH.toDashboard;
  }

  // 8.2 Onboarding → Dashboard (key milestone)
  if (from === "/onboarding" && to === "/dashboard") {
    return ONBOARDING.toDashboard;
  }

  // 8.3 Dashboard & Navigation
  if (from === "/dashboard" && to === "/letter") return NAV.toEditor;
  if (from === "/letter" && to === "/dashboard") {
    return NAV.toDashboardFromEditor;
  }
  if (from === "/dashboard" && to === "/settings") return NAV.toSettings;
  if (from === "/settings" && to === "/dashboard") return NAV.fromSettings;
  if (from === "/letter" && to === "/settings") return NAV.toSettings;
  if (from === "/settings" && to === "/letter") return NAV.toEditor;

  // Fallbacks by destination
  if (to === "/onboarding") return AUTH.toOnboarding;
  if (to === "/dashboard") return AUTH.toDashboard;
  if (to === "/settings") return NAV.toSettings;
  if (to === "/letter") return NAV.toEditor;
  if (to === "/signup") return AUTH.loginToSignup;
  if (to === "/forgot-password" || to === "/reset-password") {
    return AUTH.loginToReset;
  }
  if (isAuthPath(to)) return AUTH.signupToLogin;

  return AUTH.toDashboard;
}

export function getRouteTransitionKey(pathname = "") {
  return normalizePath(pathname);
}
